import { WithClassnames } from '@vertex-protocol/web-common';
import { MouseEventHandler, ReactNode } from 'react';

interface Props extends WithClassnames {
  isPrivate?: boolean;
  onClick?: MouseEventHandler<Element>;
  children?: ReactNode;
}

/**
 * Stack'd Perps stub: always renders children (privacy mode is not supported).
 */
export function PrivateContent({ children, className, onClick }: Props) {
  return (
    <span className={className} onClick={onClick as MouseEventHandler<HTMLSpanElement>}>
      {children}
    </span>
  );
}
